import { Outlet, NavLink } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { User, ShoppingBag, MapPin, FileSearch, LogOut, BadgePercent, Receipt, Sparkles, Bell } from "lucide-react";

const NAV = [
  { to: "/account", end: true, label: "Profile", icon: User, test: "account-nav-profile" },
  { to: "/account/orders", label: "My orders", icon: ShoppingBag, test: "account-nav-orders" },
  { to: "/account/invoices", label: "Invoices", icon: Receipt, test: "account-nav-invoices" },
  { to: "/account/points", label: "Loyalty points", icon: Sparkles, test: "account-nav-points" },
  { to: "/account/watchlist", label: "Stock watchlist", icon: Bell, test: "account-nav-watchlist" },
  { to: "/account/addresses", label: "Saved addresses", icon: MapPin, test: "account-nav-addresses" },
  { to: "/account/coas", label: "My COA submissions", icon: FileSearch, test: "account-nav-coas" },
  { to: "/account/affiliate", label: "Affiliate program", icon: BadgePercent, test: "account-nav-affiliate" },
];

export default function AccountLayout() {
  const { user, logout } = useAuth();
  return (
    <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 py-10">
      <div className="eyebrow">Account</div>
      <h1 className="h-display text-4xl mt-2">Hello, {user?.name?.split(" ")[0] || "researcher"}.</h1>
      <div className="grid grid-cols-1 lg:grid-cols-[240px_1fr] gap-8 mt-10">
        <aside className="border border-[var(--line)] rounded-md bg-[var(--paper-2)] overflow-hidden h-fit" data-testid="account-sidebar">
          <nav className="py-2">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.end}
                data-testid={n.test}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-4 py-2.5 text-sm border-l-2 ${
                    isActive ? "border-[var(--terra)] bg-[var(--paper-3)] text-[var(--terra)] font-semibold" : "border-transparent text-[var(--ink)] hover:bg-[var(--paper-3)]"
                  }`
                }
              >
                <n.icon className="h-4 w-4" strokeWidth={1.6} /> {n.label}
              </NavLink>
            ))}
          </nav>
          <div className="border-t border-[var(--line)] px-4 py-3">
            <div className="font-mono text-[10.5px] tracking-[0.18em] uppercase text-[var(--ink-muted)]">Signed in as</div>
            <div className="font-mono text-xs mt-1 truncate">{user?.email}</div>
            <button onClick={logout} className="mt-3 inline-flex items-center gap-2 text-xs font-mono uppercase tracking-wider text-[var(--rust)] hover:underline" data-testid="account-sign-out">
              <LogOut className="h-3.5 w-3.5" /> Sign out
            </button>
          </div>
        </aside>
        <main className="min-w-0">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
